import { MapPin, Clock, ClipboardList, ScanFace, Target, QrCode, BrainCircuit, LayoutDashboard, ShieldCheck, Headphones } from "lucide-react";

const features = [
  { 
    icon: MapPin, 
    title: "Real-Time GPS Map", 
    desc: "Monitor your entire security team on a live interactive map. Track officer patrol trails, verify live positions, and define custom geofence boundaries for total site coverage." 
  },
  { 
    icon: Clock, 
    title: "Hourly Scheduling", 
    desc: "Optimize security operations with automated checkpoint schedules. Features include custom time windows, variance tracking, and instant overdue alerts for missing patrols." 
  },
  { 
    icon: ClipboardList, 
    title: "Full Check-in Log", 
    desc: "Maintain a legally-defensible audit trail. Every patrol is logged with precise timestamps, high-accuracy GPS coordinates, and the specific biometric verification method used." 
  },
  { 
    icon: ScanFace, 
    title: "Biometric Face Verification", 
    desc: "Ensure absolute accountability with AI-powered liveness detection. Our facial recognition technology verifies that the correct officer is present at the designated checkpoint." 
  },
  { 
    icon: Target, 
    title: "GPS Geofencing", 
    desc: "Advanced geofence technology ensures officers are physically present. Check-ins are only permitted within a configurable radius of the specific asset or site location." 
  },
  { 
    icon: QrCode, 
    title: "QR Code Checkpoints", 
    desc: "Simple, effective physical verification. Deploy weather-resistant QR codes at key locations for quick tap-and-scan verification by patrolling security personnel." 
  },
  { 
    icon: BrainCircuit, 
    title: "AI Incident Analysis", 
    desc: "Streamline reporting with natural language processing. Officers describe incidents in plain text, and our AI automatically categorizes severity and suggests immediate actions." 
  },
  { 
    icon: LayoutDashboard, 
    title: "Multi-Site Dashboard", 
    desc: "Gain a bird's-eye view of your entire portfolio. Monitor multiple sites simultaneously with advanced filtering by location, officer performance, and site compliance status." 
  },
  { 
    icon: ShieldCheck, 
    title: "Secure Shift Login", 
    desc: "Protect sensitive data with shift-rotating password protocols. Our authentication process combines secure generated keys with biometric reveal for maximum security." 
  },
  { 
    icon: Headphones, 
    title: "24/7 Expert Support", 
    desc: "Never operate alone. Our dedicated support team is available around the clock via live chat, email, and phone to assist your security operations anytime, day or night." 
  },
];

const FeaturesSection = () => (
  <section id="features" className="py-24">
    <div className="mx-auto max-w-7xl px-6">
      <p className="text-sm font-semibold tracking-widest text-primary">SecureFlex Features</p>
      <h2 className="mt-2 text-3xl font-bold md:text-5xl">EVERYTHING YOUR OPERATION NEEDS</h2>
      <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {features.map((f, i) => (
          <div key={f.title} className="group rounded-xl border border-border bg-card p-8 transition-colors hover:border-primary/40 animate-fade-in" style={{ animationDelay: `${i * 0.07}s`, animationFillMode: "backwards" }}>
            <f.icon className="mb-4 h-8 w-8 text-primary" />
            <h3 className="mb-2 text-lg font-bold">{f.title}</h3>
            <p className="text-sm text-muted-foreground">{f.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default FeaturesSection;
